import axios from 'axios';
import { toastr } from 'react-redux-toastr';

import { URL } from '../../assets/js/constants';
import { toggleShowDialog } from './dialog';

export function campanhaLoading(data) {
    return {
        type: 'CAMPANHA_LOADING',
        payload: data
    }
}

export function campanhasFetched(data) {
    return {
        type: 'CAMPANHAS_FETCHED',
        payload: data
    }
}

export function campanhaFetched(data) {
    return {
        type: 'CAMPANHA_FETCHED',
        payload: data
    }
}

export function campanhaSaved() {
    return {
        type: 'CAMPANHA_SAVED',
        payload: null
    }
}

export function carregarUploadedFiles(data) {
    return {
        type: 'UPLOADED_FILES',
        payload: data
    }
}

function atualizarUploadedFiles(data) {
    return {
        type: 'UPDATE_UPLOADED_FILES',
        payload: data
    }
}

function veiculosPublicidadeAtivosFetched(data) {
    return {
        type: 'VEICULOS_PUBLICIDADE_ATIVOS_FETCHED',
        payload: data
    }
}

export function addCampanha(values) {
    return dispatch => {
        const formData = new FormData();

        if (values.file) {
            formData.append('file', values.file);
        }

        formData.append('conteudo', JSON.stringify(
            {
                id: values.id,
                titulo: values.titulo,
                conteudo: values.conteudo,
                conteudoExpandido: values.conteudoExpandido,
                imagemBanner: values.imagemBanner,
                targetType: values.targetType,
                targetId: values.targetId,
                actionType: values.actionType,
                actionPayload: values.actionPayload,
                dataInicioVeiculacao: values.dataInicioVeiculacao,
                dataFimVeiculacao: values.dataFimVeiculacao,
                ativo: values.ativo,
                veiculos: values.veiculos
            }
        ));

        axios.post(`${URL}/publicidade`, formData, {
            // O Axios define o Content-Type: multipart/form-data automaticamente com FormData
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                // O idTemp aqui é único para cada arquivo disparado no loop
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, progress }));
            }
        })
            .then(resp => {
                dispatch(atualizarUploadedFiles({
                    idTemp: values.idTemp,
                    url: resp.data.url,
                    uploaded: true,
                }));
            })
            .catch(() => {
                toastr.error('Erro', `Falha ao subir ${values.file.name}`);
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, error: true }));
            });
    }
}

export function atualizarCampanha(values) {
    return dispatch => {
        const formData = new FormData();

        if (values.file) {
            formData.append('file', values.file);
        }

        formData.append('conteudo', JSON.stringify(
            {
                id: values.id,
                titulo: values.titulo,
                conteudo: values.conteudo,
                conteudoExpandido: values.conteudoExpandido,
                imagemBanner: values.imagemBanner,
                targetType: values.targetType,
                targetId: values.targetId,
                actionType: values.actionType,
                actionPayload: values.actionPayload,
                dataInicioVeiculacao: values.dataInicioVeiculacao,
                dataFimVeiculacao: values.dataFimVeiculacao,
                ativo: values.ativo,
                veiculos: values.veiculos
            }
        ));

        axios.put(`${URL}/publicidade`, formData, {
            // O Axios define o Content-Type: multipart/form-data automaticamente com FormData
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                // O idTemp aqui é único para cada arquivo disparado no loop
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, progress }));
            }
        })
            .then(resp => {
                dispatch(atualizarUploadedFiles({
                    idTemp: values.idTemp,
                    url: resp.data.url,
                    uploaded: true,
                }));
            })
            .catch(() => {
                toastr.error('Erro', `Falha ao subir ${values.file.name}`);
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, error: true }));
            });
    }
}

export function getCampanhas() {
    return dispatch => {
        dispatch(campanhaLoading(true));
        axios.get(`${URL}/publicidade`)
            .then(resp => {
                dispatch(campanhasFetched(resp.data));
                dispatch(campanhaLoading(false));
            })
            .catch(() => {
                dispatch(campanhaLoading(false));
                toastr.error('Erro', 'Falha ao buscar campanhas. Tente novamente em alguns instantes');
            })
    }
}

export function getCampanha(id) {
    return dispatch => {
        dispatch(campanhaLoading(true));
        axios.get(`${URL}/publicidade/${id}`)
            .then(resp => {
                dispatch(campanhaFetched(resp.data));
                dispatch(campanhaLoading(false));
            })
            .catch(() => {
                dispatch(campanhaLoading(false));
                toastr.error('Erro', 'Falha ao buscar a campanha. Tente novamente em alguns instantes');
            })
    }
}

export function getVeiculoPublicidadeAtivos() {
    return dispatch => {
        dispatch(campanhaLoading(true));
        axios.get(`${URL}/publicidade/veiculos-ativos`)
            .then(resp => {
                dispatch(veiculosPublicidadeAtivosFetched(resp.data));
                dispatch(campanhaLoading(false));
            })
            .catch(() => {
                dispatch(campanhaLoading(false));
                toastr.error('Erro', 'Falha ao buscar veículos de publicidade ativos. Tente novamente em alguns instantes');
            })
    }
}